import { Switch, Redirect, useRouteMatch } from "react-router-dom";

import PrivateRoute from "../../components/PrivateRoute";

import AdminAuctionsTabNav from "../components/AdminAuctionsTabNav";
import AuctionHeader from "../components/AuctionHeader";
import Input from "./Input";
import Bids from "./Bids";
import WhatIf from "./WhatIf";
import Completions from "./Completions";
import BidBoard from "./BidBoard";
import Chat from "./Chat";
import Online from "./Online";
import Rebuild from "./Rebuild";
import Tracts from "./Tracts";
import Settings from "./Settings";
import GraphicalViewerSetup from "./GraphicalViewerSetup";
import GraphicalViewer from "./GraphicalViewer";
import classNames from "../../utilities/classNames";

export default function AuctionInput() {
    const { url } = useRouteMatch();

    const shouldShow =
        window.location.pathname.includes("/graphical-viewer") === false;

    return (
        <>
            <div className={classNames("mb-8", !shouldShow && "hidden")}>
                <AuctionHeader />
                <AdminAuctionsTabNav base={`${url}`} />
            </div>
            <Switch>
                <PrivateRoute exact path={`${url}/input`}>
                    <Input />
                </PrivateRoute>
                <PrivateRoute path={`${url}/bids`}>
                    <Bids />
                </PrivateRoute>
                <PrivateRoute path={`${url}/what-if`}>
                    <WhatIf />
                </PrivateRoute>
                <PrivateRoute path={`${url}/tracts`}>
                    <Tracts />
                </PrivateRoute>
                <PrivateRoute path={`${url}/graphical-viewer`}>
                    <GraphicalViewer />
                </PrivateRoute>
                <PrivateRoute path={`${url}/setup-graphical-viewer`}>
                    <GraphicalViewerSetup />
                </PrivateRoute>
                <PrivateRoute path={`${url}/completions`}>
                    <Completions />
                </PrivateRoute>
                <PrivateRoute path={`${url}/bid-board`}>
                    <BidBoard />
                </PrivateRoute>
                <PrivateRoute path={`${url}/chat`}>
                    <Chat />
                </PrivateRoute>
                <PrivateRoute path={`${url}/online`}>
                    <Online />
                </PrivateRoute>
                <PrivateRoute path={`${url}/settings`}>
                    <Settings />
                </PrivateRoute>
                <PrivateRoute path={`${url}/rebuild`}>
                    <Rebuild />
                </PrivateRoute>
                <Redirect from={`${url}/`} to={`${url}/input`} />
            </Switch>
        </>
    );
}
